import { GoodsTrackingTemplate } from '@/api/index'

export function goodsCustomerInformationTemplateDelete (data: any) {
  return GoodsTrackingTemplate.request({
    method: 'post',
    url: '/CustomerInformationTemplateDelete',
    data
  })
}
export function goodsCustomerSavePGSData (data: any) {
  return GoodsTrackingTemplate.request({
    method: 'post',
    url: '/SavePGSData',
    data
  })
}
export function goodsCustomerGetPageGridBond (data: any) {
  return GoodsTrackingTemplate.request({
    method: 'post',
    url: '/GetPageGridBond',
    data
  })
}
